import { Mail, Phone } from 'lucide-react';

const openWhatsApp = () => {
    const phoneNumber = "919030618006"; // replace with your WhatsApp number (country code + number)
    const message = "Hi, I would like to book a shoot with TagTeam Studios.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
};

// Contact Section
const ContactSection = () => {
  return (
    <section
      id="contact"
      className="bg-neutral-900 py-16 md:py-24 lg:py-40 relative overflow-hidden"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-0 w-60 h-60 sm:w-80 sm:h-80 md:w-96 md:h-96 border border-white rounded-full -translate-x-1/3 -translate-y-1/3" />
        <div className="absolute bottom-0 right-0 w-[350px] h-[350px] sm:w-[450px] sm:h-[450px] md:w-[600px] md:h-[600px] border border-white rounded-full translate-x-1/4 translate-y-1/4" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center relative z-10">
        {/* Tagline */}
        <span className="text-[#d4af37] text-[0.65rem] sm:text-xs tracking-[0.35em] block mb-3 sm:mb-4">
          GET IN TOUCH
        </span>

        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white font-serif font-light leading-tight">
          Let's Create
          <span className="italic text-[#d4af37] block mt-1">Magic Together</span>
        </h2>

        {/* Description */}
        <p className="text-neutral-400 mt-6 sm:mt-8 text-base sm:text-lg max-w-xl mx-auto leading-relaxed px-2">
          Your story is unique. Let us craft visuals that honor every moment,
          every emotion, every detail.
        </p>

        {/* Contact Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-10 sm:mt-12">
          <a
            href="mailto:hello@tagteamstudios.com"
            className="cursor-pointer flex items-center gap-3 text-white hover:text-[#d4af37] transition-colors duration-300 text-sm sm:text-base"
          >
            <Mail className="w-5 h-5" />
            <span>hello@tagteamstudios.com</span>
          </a>

          <span className="hidden sm:block text-neutral-600">|</span>

          <a
            href="tel:+919030618006"
            className="cursor-pointer flex items-center gap-3 text-white hover:text-[#d4af37] transition-colors duration-300 text-sm sm:text-base"
          >
            <Phone className="w-5 h-5" />
            <span>+91 90306 18006</span>
          </a>
        </div>

        {/* CTA Button */}
        <button
          onClick={openWhatsApp}
          className="cursor-pointer inline-block mt-12 sm:mt-16 px-10 sm:px-12 py-4 sm:py-5 bg-[#d4af37] text-neutral-950 tracking-[0.2em] text-xs sm:text-sm font-medium hover:bg-white transition-colors duration-500"
        >
          BOOK A SESSION
        </button>

        {/* Social Links */}
        <div className="flex justify-center gap-6 sm:gap-8 mt-12 sm:mt-16">
            <a
              href="https://www.instagram.com/tagteamstudios?igsh=M3V5eGZhOTU0NXI3"
              target='__blank'
              className="cursor-pointer text-neutral-500 hover:text-[#d4af37] text-[0.7rem] sm:text-xs tracking-[0.3em] transition-colors duration-300"
            >
              INSTAGRAM
            </a>
            <a
              href="https://youtube.com/@tagteamstudios681?si=HocRADtzo0aoEJyQ"
              target='__blank'
              className="cursor-pointer text-neutral-500 hover:text-[#d4af37] text-[0.7rem] sm:text-xs tracking-[0.3em] transition-colors duration-300"
            >
              YOUTUBE
            </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
